import { ITenant } from "@oneethos/shared"

type LoanOptionCardProps = {
  financingTenant: ITenant
  loanTermYears: string
  loanTermMonths: number
  interestWithAutoPay: number
  estimatedPaymentWithAutopay: string
  estimatedPaymentWithOutAutopay: string
  interestOnlyPeriod: number
  isConsumerView?: boolean
  isDisabled?: boolean
  getProduct?: () => void
  isSelected?: boolean
  apr?: number
  isResidential?: boolean
}

const LoanOptionCard = ({
  financingTenant,
  loanTermYears,
  interestWithAutoPay,
  estimatedPaymentWithAutopay,
  interestOnlyPeriod,
  isSelected,
  isConsumerView,
  isDisabled,
  apr,
  getProduct,
  isResidential,
}: LoanOptionCardProps) => {
  const classes = isConsumerView
    ? [
      isDisabled && 'opacity-50 pe-none',
      isSelected && 'selected',
    ].filter(Boolean).join(' ')
    : 'border rounded-2'

  return (
    <div className={[`card loan-option-card`, classes].filter(Boolean).join(' ')}>
      <div className="my-3">
        <div className="loan-option-card-details">
          <div className="monthly-payment">
            <span className="mp-amt">{estimatedPaymentWithAutopay}</span>/mo*
          </div>
          <div className="rates">
            {apr ? <div className="rate apr">
              <div className="rate-amt">{apr}%</div>
              <div className="rate-label">APR**</div>
            </div> : null}
            <div className="rate interest">
              <div className="rate-amt">{interestWithAutoPay.toFixed(2)}%</div>
              <div className="rate-label">rate</div>
            </div>
          </div>
          <div><strong>{loanTermYears} years</strong></div>
          <div><strong>No Dealer Fee</strong></div>
          {interestOnlyPeriod ?
            <div>
              <strong>
                {isResidential
                  ? `${interestOnlyPeriod} Months No Payments`
                  : `${interestOnlyPeriod} Months Interest Only`}
              </strong>
            </div> : null}
        </div>
      </div>
      <div>
        <img src={`/api/tenant/logo/${financingTenant._id}`} loading="lazy" id="logo" className="logo" />
      </div>
      {isConsumerView ? <>
        {isSelected ? <div className="is-selected mt-3">Selected</div> : <button
          className={`btn mt-3 btn-${isDisabled ? `outline-secondary` : `primary`}`}
          disabled={isDisabled}
          onClick={getProduct}
        >
          {isDisabled ? 'Not Eligible' : 'Select'}
        </button>}
      </> : null}
    </div>
  )
}

export default LoanOptionCard